/*
 * @Author: jerryfwang
 * @Date: 2019-08-21 15:04:39
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2021-12-21 17:56:12
 */
// @flow
import React, { Component } from 'react';
import { isIOS } from '@tencent/qb-article-util/lib/UA';
import './index.scss';
type Props = {
  sTitleLogo?: string,
};
export default class Mark extends Component<Props, *> {
  constructor(props: Props) {
    super(props);
    this.state = {
      lineHeight: '27px',
    };
  }
  componentDidMount() {
    if (typeof window !== 'undefined' && window.navigator) {
      const isIos = isIOS(window.navigator.userAgent);
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        lineHeight: isIos ? '25px' : '27px',
      });
    }
  }
  render() {
    const { sTitleLogo } = this.props;
    if (!sTitleLogo) {
      return null;
    }
    return (
      <div className="titleMark">
        <span className="title-mark--txt" style={{ lineHeight: this.state.lineHeight }}>
          {sTitleLogo}
        </span>
        <div className="title-mark--mark" />
      </div>
    );
  }
}
